define(['./config.js', './util.js', './component-instance.js'], function(config, util, ComponentInstance) {
    'use strict';

    var instanceRegistry = {
        init: init,
        reset: reset,
        register: register,
        get: get,
        findAll: findAll,
        find: find,
        findByType: findByType,
        all: all
    };

    var instances = {};

    function init() {
        reset();
        var modulePaths = config.getModulePaths();
        util.each(modulePaths, function(val, path) {
            var instance = register(path);
            //instance.getSettings();
            //instance.getLabels();
        });
    }

    function reset() {
        util.each(instances, function(instance) {
            instance.destroy();
        });

        instances = {};
    }

    function register(modulePath, options) {
        if (instances.hasOwnProperty(modulePath)) {
            return instances[modulePath];
        }

        if (config.canAddModulePathDynamically(modulePath) && options && options.type && !config.hasInstance(modulePath)) {
            config.addInstance(modulePath, options);
        } else if (!config.hasInstance(modulePath)) {
            throw new Error('(instanceRegistry) tried to register a module path that does not exist in the config');
        }

        var component = new ComponentInstance(modulePath, instanceRegistry);
        instances[modulePath] = component;
        return component;
    }

    function all() {
        return instances;
    }

    /** Find the first instance that matches the given search string. * can be used as "match all".
     * @param search
     */
    function find(search) {
        var regex = _getFindRegex(search);
        for (var k in instances) {
            if (instances.hasOwnProperty(k) && regex.test(k)) {
                return instances[k];
            }
        }
    }

    /** Find all instances that match the given search string. * can be used as "match all".
     * @param {string} search
     */
    function findAll(search) {
        var regex = _getFindRegex(search);
        return util.filter(instances, function(item, key) {
            return regex.test(key);
        });
    }

    function findByType(type) {
        return util.filter(instances, function(instance, key) {
            return instance.getModuleType() === type;
        });
    }

    function _getFindRegex(search) {
        if (!util.isString(search)) {
            return new RegExp(search);
        } else {
            search = search.replace(/\./g, '\\.')
            .replace(/\*/g, '.*');
            return new RegExp('^' + search + '$');
        }
    }

    function get() {
        if (arguments.length === 2) {
            var relativePath = util.isPlainObject(arguments[1]) ? null : arguments[1];

            if (relativePath != null) {
                var modulePath = util.componentPath.resolve(arguments[0], relativePath);
                if (!instances[modulePath]) {
                    throw new Error('(instanceRegistry) could not find any instance for: ' + modulePath);
                }

                return instances[modulePath];
            } else {
                return register(arguments[0], arguments[1]);
            }
        } else if (arguments.length === 1) {
            if (!instances[arguments[0]]) {
                throw new Error('(instanceRegistry) could not find any instance for: ' + arguments[0]);
            }

            return instances[arguments[0]];
        } else {
            throw new Error('(instanceRegistry) get expects 1 or 2 arguments');
        }
    }

    return instanceRegistry;
});



/*****************
 ** WEBPACK FOOTER
 ** ./components/core/src/js/instance-registry.js
 ** module id = 118
 ** module chunks = 0
 **/